/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { calendarConnectionDestroy } from '../../axios/calendarConnectionDestroy'
import type {
	CalendarConnectionDestroyError,
	CalendarConnectionDestroyPathParams,
	CalendarConnectionDestroyResponse,
} from '../../types/CalendarConnectionDestroy'

export const calendarConnectionDestroyMutationKey = () => [{ url: '/calendar-integrations/connections/:id' }] as const

export type CalendarConnectionDestroyMutationKey = ReturnType<typeof calendarConnectionDestroyMutationKey>

export type CalendarConnectionDestroyVariables = {
	id: CalendarConnectionDestroyPathParams['id']
}

/** @see backend/nexus/modules/CalendarIntegrations/Http/Controllers/CalendarConnectionController.php CalendarConnectionController::destroy */
export function useCalendarConnectionDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		CalendarConnectionDestroyResponse,
		AxiosError<CalendarConnectionDestroyError>,
		CalendarConnectionDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: calendarConnectionDestroyMutationKey(),
		mutationFn: ({ id }: CalendarConnectionDestroyVariables) =>
			calendarConnectionDestroy(id, config).then(res => res.data),
		...options,
	})
}
